import StvSelbstbeteiligung, { getFormText, getGoogleTagManagerSbValue, getInfoText, getInfoTitel } from "../../../../../consumer/form/dto/StvSelbstbeteiligung";
import useWizardFormCtx from "../../ctx-provider/useWizardFormCtx";
import { Typography } from "@material-ui/core";
import SelectField from "../../../../cmp/input/SelectField";
import SelectMenuItem from "../../../../cmp/input/SelectMenuItem";
import InfoBtn from "../../../../cmp/info/InfoBtn";
import FormBo from "../FormBo";
import { useState } from "react";
import GtmInfoBtnId from "../../../../../gtm/types/GtmInfoBtnId";
import GoogleTagManager from "../../../../../gtm/GoogleTagManager";
import GtmFormulareingabeField from "../../../../../gtm/types/GtmFormulareingabeField";
import GtmFormularfeldId from "../../../../../gtm/types/GtmFormularfeldId";

export const exportSelbstbehalt = (bo: FormBo) => bo.selbstbehalt;

const Selbstbehalt: React.FC<{ disabled: boolean }> = ({ disabled }) => {
    const { wizardFormBo, fireWizardFormBo } = useWizardFormCtx();
    const [selbstbehalt, setSelbstbehalt] = useState(wizardFormBo.angebot.selbstbehalt);

    const infoTxt = getInfoText();
    const infoTitel = getInfoTitel();

    // *** Formulardaten werden aktualisiert
    const handleOnChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const value = event.target.value;
        const valueEnum = StvSelbstbeteiligung[value as keyof typeof StvSelbstbeteiligung];
        setSelbstbehalt(valueEnum);

        wizardFormBo.angebot.selbstbehalt = valueEnum;
        fireWizardFormBo(wizardFormBo);

        // Google Tag Manager
        GoogleTagManager.fireEventFormulareingabe(GtmFormulareingabeField.SB, getGoogleTagManagerSbValue(valueEnum));
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <SelectField
                id='SB'
                disabled={disabled}
                idGtm={GtmFormularfeldId.produktSb}
                value={selbstbehalt}
                onChange={handleOnChange}>
                <SelectMenuItem value={StvSelbstbeteiligung.OHNE}>{getFormText(StvSelbstbeteiligung.OHNE)}</SelectMenuItem>
                <SelectMenuItem value={StvSelbstbeteiligung.SB_150}>{getFormText(StvSelbstbeteiligung.SB_150)}</SelectMenuItem>
            </SelectField>
            <Typography variant='body1' color='textPrimary' display='inline' style={{ marginLeft: 10 }}>Selbstbeteiligung</Typography>
            <InfoBtn titel={infoTitel} text={infoTxt} gtmId={GtmInfoBtnId.SB} />
        </div>);
}

export default Selbstbehalt;